import { TConferenceProcessSteps } from '../../../../../common/rest/conference/conferenceRest';

// url segment for each tab; '' (Recording) is the page's own default route with no trailing segment
export enum EAudioPageTab {
  RECORDING = '',
  EXERCISES = 'exercises',
  WORDS = 'words',
  BOOK = 'book',
}

export interface IAudioPageFields {
  title: string;
  date: string; // settings popup header
  audioId?: number;
  canEditSettings: boolean; // call recordings only — the settings live on the conference
  progressLog: string[];
  isProcessing: boolean;
  progressStartedAt?: number;
  progressStepStartedAt?: number;
  progressUpdatedAt?: number;
}

export interface IAudioPageEvents {
  onChangeRoute: (groupId: number, audioId: number) => void;
  onChangeTab: (groupId: number, audioId: number, tab: EAudioPageTab) => void;
  onReprocess: (force?: boolean, steps?: TConferenceProcessSteps) => Promise<any>;
  onCancel: () => Promise<any>;
  onCloseSettings: () => void;
  onPlayTimestamp: (time: number) => void;
  onPlayCaption: (index: number) => void;
  onPause: () => void;
}

export interface IAudioPageProps extends IAudioPageFields, IAudioPageEvents {}
